/** @deprecated Use isInCollection below */
export default function isInFavoritesFunction(favoritesCollection, diagnostic) {
  return favoritesCollection.findIndex((favoriteDiagnostic) => favoriteDiagnostic.code === diagnostic.code) !== -1;
}

export function isInCollection(collection, element) {
  return collection.findIndex((collectionElement) => collectionElement.code === element.code) !== -1;
}
